import React from 'react'
import styled from 'styled-components'
import webdevelopment from '../assets/Group 187.png'
// import websitecover from '../assets/Group 134 (1).png'
// import websitecober1 from '../assets/pngwing 1.png'
import bannermobile from '../assets/House 1.png'
import serviceImage from '../assets/image 107.png';
import serviceImage1 from '../assets/image 108.png';
import serviceImage2 from '../assets/image 111.png';
import serviceImage3 from '../assets/image 908.png';
import serviceImage4 from '../assets/image 105.png';
import imageuiux from '../assets/Group 194.png'
import Rectangle111 from '../assets/Rectangle 1a.png'
import Rectangle112 from '../assets/Rectangle 1b.png'
import Rectangle113 from '../assets/Rectangle 1c.png'
import Rectangle114 from '../assets/Rectangle 1d.png'
import Rectangle115 from '../assets/Rectangle 1e.png'
import Rectangle1111 from '../assets/Rectangle 1f.png'
import Rectangle1122 from '../assets/Rectangle 1g.png'
import Rectangle1133 from '../assets/Rectangle 1h.png'
import Rectangle1144 from '../assets/Rectangle 1i.png'
import Rectangle1155 from '../assets/Rectangle 1k.png'
import Rectangle116 from '../assets/Rectangle 116 (1).png'
import Rectangle117 from '../assets/image 100.png'
import Rectangle118 from '../assets/Rectangle 112 (1).png'
import { useState } from 'react'

const MainWrapContanier = styled.div``
const MobileAppImage = styled.img`
position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  object-fit: cover;
  z-index: -1;
  @media (max-width:600px){
  width:100%;
  height:auto;
}
@media (min-width:601px) and (max-width:1024px){
  width:100%;
  height:auto;
}
`
// const MobileAppImage1 = styled.img`
// position: absolute;
// top: 0;
// left: 0;
//   width: 888px;
//   height: 602px;
//   object-fit: cover;
//   z-index: 100;
//   margin-top: 64px;

// `
// const MobileAppImage2 = styled.img`
// position: absolute;
// top: 0;
// right: 0;
//   width: 200px;
//   height: 68px;
//   object-fit: cover;
//   z-index: 100;
//   margin-top: 100px;
//   margin-right: 150px;

// `

const ContanierHead1 = styled.h1`
color:darkblue;
font-size: 42px;
margin-top: 20px;
margin-bottom: 20px;
text-align: center;
line-height: 1.5;
`
const ContanierPara7 = styled.p`
text-align: center;
justify-content: center;
margin-left: 175px;
margin-right: 175px;
font-size: 23px;
/* padding:80px; */
margin-top:50px;
margin-bottom: 50px;

line-height:2;
`
const MobileHeadPara = styled.div``
const Div = styled.div`

/* position: absolute; */
`

const MainCont = styled.div`


`
// const HeadH2 = styled.h1`
//   position: absolute;
//   z-index: 100;
//   right: 0;
//   margin-top: 200px;
//   margin-right: 100px;
//   color:white;
//   font-size: 40px;
//   top: 0;
//   text-align: center;

// `
const ContanierHead = styled.div`
  width:100%;
  height:500px;
  /* background-color: red; */
  display:flex;
  justify-content: center;
  align-items: center;
  text-align:center ;
  box-sizing:border-box;
  padding:50px;
  /* padding-left:150px; */
  gap: 40px;
  @media (max-width:600px) {
    width:100%;
    height: auto;
    flex-direction: column;
    padding:10px;
  }
  @media (max-width:600px) {
    
    flex-direction: column-reverse;
    
  }

  @media (min-width:601px) and (max-width:1024px){
    width:100%;
    height: auto;
    flex-direction: column;
    padding:10px;
}
@media (min-width:601px) and (max-width:1024px){
  flex-direction: column-reverse;
}
@media (min-width:1025px) and (max-width:1300px){
  gap:0px
}
@media (min-width:1301px) and (max-width:1440px){
  height:550px;

}
@media (min-width:1441px) and (max-width:2100px){
  height:600px;
  margin-bottom: 100px;
  gap:0px
}
`
const ContanierMobile = styled.div`
  width:50%;
  /* padding-top:50px; */
  height:400px;
  align-items: center;
  text-align: center;
  justify-content: center;
  /* background-color: blue; */
  @media (max-width:600px) {
    width:100%;
    height: auto;
  
  }
  @media (min-width:601px) and (max-width:1024px){
    width:90%;
    height: auto;
    
}
@media (min-width:1025px) and (max-width:1300px){
  width:70%;
  height: auto;
}
@media (min-width:1301px) and (max-width:1440px){
    
    height: 500px;
    
}
@media (min-width:1441px) and (max-width:2100px){
  height:550px;
  padding-top:100px;
}
`
const MobileImage = styled.img`
width:85%;
height:300px;
justify-content: center;
align-items: center;
margin-left: 0px;
@media (max-width:600px){
    width:50%;
    height:auto;
  }
  @media (min-width:601px) and (max-width:1024px){
    width:70%;
    height: auto;
    
}
@media (min-width:1301px) and (max-width:1440px){
    
    height: auto;
    
}
@media (min-width:1441px) and (max-width:2100px){
  height: auto;
  width:70%;
}
`
const ContanierRhtHead = styled.h1`
  width: 45%;
  height: 400px;
  /* background-color: yellow; */
  font-size: 60px;
  text-align: center;
  align-items: center;
  padding-top: 60px;
  @media (max-width:600px) {
    width:100%;
    height: auto;
    font-size: 40px;
    padding-top: 20px;
    padding-bottom:20px;
  }
  @media (min-width:601px) and (max-width:1024px){
    width:100%;
    height: auto;
    font-size: 60px;
    padding-top: 20px;
    padding-bottom:20px;
}
@media (min-width:1025px) and (max-width:1300px){
    width:100%;
    height: auto;
    font-size: 60px;
    padding-top: 20px;
    padding-bottom:20px;
}
@media (min-width:1301px) and (max-width:1440px){
  padding-top: 150px;
    height: 500px;
    
}
@media (min-width:1441px) and (max-width:2100px){
  height:550px;
  padding-top: 170px;
  padding-left: 150px;
  font-size: 70px;
  
}
`
const MobilePara = styled.p`
font-size: 20px;
margin-top:20px;
color:green;
`
const Container19 = styled.div`
/* background-color: yellow; */
  position: relative;
  margin-top: 10px;
  width: 100%;
  align-items: center;
  z-index: 1;
  box-sizing: border-box;
  height: 900px;
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  @media screen and (max-width:600px){
    width:100%;
    max-width:99%;
    height: auto;
    height: 2500px;
  }
  @media (min-width:601px) and (max-width:638px){
  width:100%;
    max-width:99%;
    height: auto;
    height: 2400px;
}
  @media (min-width:639px) and (max-width:814px){
  width:100%;
    max-width:99%;
    height: auto;
    height: 1450px;
}
@media (min-width:815px) and (max-width:973px){
  width:100%;
    max-width:99%;
    height: auto;
    height: 1450px;
}
@media (min-width:1025px) and (max-width:1300px){
  width:100%;
    max-width:99%;
    height: auto;
    height: 1000px;
}
@media (min-width:1301px) and (max-width:1627px){
  width:100%;
    max-width:99%;
    height: auto;
    height: 1000px;
}
@media (min-width:1628px) and (max-width:2100px){
  width:100%;
  height:500px;
}
  
`;
const Div3 = styled.div`
 width:100%;
height:auto;
  position: relative;
  background-color:green;
  align-items: center;
  justify-content: center;
  align-items: center;
  @media screen and (max-width:600px){
    width:100%;
    height: auto;
    
  }
`;
const PageContainer2 = styled.div`
  position: relative;
  width: 80%;
  height: 830px;
  z-index: 100;
  /* background-color: red; */
  margin-left: 140px;
  @media screen and (max-width:430px){
  display:flex;
  /* overflow: scroll; */
  height:590px;
  width:90%;
  margin:20px;
  }
`;
const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
  align-items: center;
  position: absolute;
  top: 3%;
  /* left: 10%; */
  box-sizing: border-box;
  z-index: 1;
  width: 100%;
  
  /* background-color: #0084ff; */
  @media screen and (max-width:600px){
      flex-direction: column;
    width:100%;
    height: auto;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  @media (min-width: 1301px) and (max-width:1440px) {
    gap: 4rem;
  }
`;
const Card = styled.div`
  position: relative;
  background-color: white;
  color: black;
  width: 300px;
  height: 400px;
  padding: 1rem;
  border-radius: 25px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  text-align: center;
  opacity: 0.8;             
  border: 1px solid black;
  
  transition: transform 0.3s ease, box-shadow 0.3s ease, opacity 0.3s ease;

  &:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    opacity: 1;
   cursor: pointer;
   border: solid 2px #1c1c7a;
    background-color:  #b6b2b2; /* Background color on hover */
    transform: scale(1.05); 
  }

  &:hover img {
     /* Change image color to grayscale on hover */
    
  }

  &:hover h3 {
    color:#1c1c7a; 
  }

  &:hover p {
    color:#1c1c7a;
  }
  @media screen and (max-width:600px){
    width: 300px;
    height: 450px;
    
    
    
    /* margin-left: 20px;
    margin-right:20px; */

  }
  
`;
const CardDescription = styled.p`
  font-size: 1rem;
  color: black;

  @media screen and (max-width:600px) {
    align-item:center;
text-align: center;
line-height: 22px;
font-size: 15px;
    
  }
`;
const CardTitle = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
  @media screen and (max-width:600px) {
    font-size: 25px;
    align-items: center;
    text-align: center;
  }
`;
const CardImage = styled.img`
  width: auto;
  height: auto;
  object-fit: cover;
  margin-bottom: 1rem;
  color: black;
`;
const HeaderWeb = styled.h1`
  color: black;
  margin-top: 30px;
  font-size: 45px;
  margin-bottom: 1rem;
  box-sizing: border-box;
  justify-content: center;
  text-align: center;
  @media screen and (max-width:600px) {
    margin-left: 0%;
    margin-top: 0px;
    font-size: 16px;
  }
  @media (min-width:601px) and (max-width:1024px){
 margin-left: 0%;
    margin-top: 0px;
    font-size: 24px;
}
@media (min-width:1441px) and (max-width:2100px){
  margin-left: 100px;
  margin-right: 100px;
  margin-bottom: 3rem;
}
`;

const Container20 = styled.div`
box-sizing: border-box;
width: 100%;
height:100%;
align-items: center;
text-align: center;
justify-content: center;
/* background-color: red; */
@media (min-width:1025px) and (max-width:1300px){
  
    width: 100%;
    height:auto;
    
}
`
const ImageUiUx = styled.img`
  width:100%;
  align-items: center;
  height:auto;
  padding-left: 20px;
  padding-right:20px;
  object-fit: cover;
  margin-top:20px;
  
  justify-content: center;
  @media screen and (max-width:600px) {
    margin: 0%;
    width: 100%;
    height:auto;
   
    margin-top:30px;
    margin-bottom:30px;
  }
  @media (min-width:601px) and (max-width:1024px){
  margin: 0%;
    width: 100%;
    height:auto;
    margin-top:30px;
    margin-bottom:30px;
}
@media (min-width:601px) and (max-width:1024px){
  margin: 0%;
    width: 100%;
    height:auto;
    margin-top:30px;
    margin-bottom:30px;
}
@media (min-width:1301px) and (max-width:1440px){
  width:100%;
  align-items: center;
  height:auto;
  object-fit: cover;
}
@media (min-width:1441px) and (max-width:2100px){
  width:100%;
  padding-left: 100px;
  padding-right:100px;
  height:auto;
}

`
const PeraWeb = styled.p`
  color: black;
  margin-top: 10px;
  font-size: 25px;
  margin-bottom: 1rem;
  text-align: center;
  box-sizing: border-box;
  align-items: center;
  
  @media (max-width:600px) {
    margin-left: 0%;
    align-item:center;
text-align: center;
line-height: 25px;
font-size: 14px;
margin:10px;
    
  }
   @media (min-width:601px) and (max-width:1024px){
 margin-left: 0%;
    align-item:center;
    font-size: 16px;
text-align: center;

margin:10px;
}
`;
const TabNavigation = styled.div`
margin-top:40px;
  width:90%;
  height:300px;
  align-items: center;
  text-align:center;
  justify-content:center;
  margin-bottom: 30px;
  background-color: #d4d4d4;
  margin-left: 60px;
  @media (max-width:600px) {
    width: 100%;
    height:auto;
    
    margin-left: 0%;
  }
  @media (min-width:601px) and (max-width:1024px){
  width: 100%;
    height:auto;
    
    margin-left: 0%;
}
@media (min-width:1025px) and (max-width:1300px){
  width: 100%;
    height:auto;
    
    margin-left: 0%;
}
@media (min-width:1441px) and (max-width:2100px){
  
  align-items: center;
  text-align:center;
  justify-content:center;
    margin-left:80px;
    
    
}

`
const Dflex = styled.ul`
display: flex;
text-decoration: none;
gap:2px;
/* display: none; */
list-style-type: none;
text-align: center;
align-items: center;
padding:3px;
margin-left:5px;
@media (max-width:600px) {
   margin-left: 0px;
  }
  @media (min-width:601px) and (max-width:1024px){
  
    
    margin-left: 0%;
}
`
const FlexFill = styled.li`
text-decoration: none;
background-color: ${props => (props.active ? '#0c0ce7' : 'white')};
color:${(props => (props.active ? 'white' : 'black'))};
/* border: 1px solid black; */
width: 50%;
height: 50px;
/* color:white; */
text-align: center;
align-items: center;
padding-top:10px;
font-size: 25px;
font-weight: bold;
cursor: pointer;
border-radius: 5px;
/* display: none; */
@media (max-width:600px) {
   margin-left: 0px;
  }


`
const TabContents = styled.div`
/* background-color:pink; */
justify-content: center;
align-items: center;
text-align: center;
width: 100%;
  height:auto;
display: ${props => (props.show ? 'block' : 'none')};
@media (max-width:600px){
  width: 100%;
  height:auto;
  
  
}
@media (min-width:601px) and (max-width:1024px){
  
   
  align-items: center;
  text-align: center;
  justify-content: center;
    width: 100%;
  height:auto;
}
@media (min-width:1025px) and (max-width:1300px){
  flex-direction: flex;
width: 100%;
  height: auto;
  align-items: center;
  text-align: center;
  justify-content: center;
}

`
const TabContents1 = styled.div`

display: ${props => (props.show ? 'block' : 'none')};
`
const TechImage = styled.img`
width: 100px;
height:100px;
margin-top:50px;
align-items: center;
`
const TechImage2 = styled.img`
width: 100px;
height:30px;
margin-top:60px;
align-items: center;
`
const TechImage1 = styled.img`

margin-top:50px;
align-items: center;
text-align: center;
justify-content: center;
`
const TechImage11 = styled.img`
width: 100px;
height:30px;
margin-top:60px;
align-items: center;
`
const CardTools = styled.div`
   width:170px;
   height:210px;
  background-color: white;
  margin: 10px;
  margin-left: 53px;
  align-items: center;
  text-align: center;
  margin-top: 40px;
  border-radius: 20px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Added transition for smooth effect */

  &:hover {
    transform: scale(1.05); /* Scale up slightly on hover */
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2); /* Darker shadow on hover */
  }
`;

const CardTools1 = styled.div`
  width:170px;
  height:210px;
  background-color:white;
  margin:10px;
  margin-left: 53px;
  align-items: center;
  text-align: center;
  margin-top: 40px;
  border-radius: 20px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Added transition for smooth effect */

&:hover {
  transform: scale(1.05); /* Scale up slightly on hover */
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2); /* Darker shadow on hover */
}
@media (max-width:600px){
  margin:0%;
  margin:20px;
  align-items: center;
  text-align: center;
  justify-content: center;
}
@media (min-width:601px) and (max-width:1024px){
  
   
 margin:0%;
  margin:20px;
  align-items: center;
  text-align: center;
  justify-content: center;
}
@media (min-width:1300px) and (max-width:1440px){
  
   
  margin:0%;
  margin:20px;
 }
@media (min-width:1441px) and (max-width:2100px){
  
   
  margin:0%;
   margin:25px;
   align-items: center;
   text-align: center;
   justify-content: center;
 }
`;
const Div2 = styled.div`
  width: 100%;
  align-items: center;
  text-align: center;
  justify-content: center;
  /* background-color: yellow; */
  height: auto;
  box-sizing: border-box;
  flex-wrap: wrap;
display: flex;
@media (max-width:600px) {
flex-direction: flex;
width: 100%;
  height: auto;
  align-items: center;
  text-align: center;
  justify-content: center;
}
@media (min-width:601px) and (max-width:1024px){
  flex-direction: flex;
width: 100%;
  height: auto;
  align-items: center;
  text-align: center;
  justify-content: center;
}
@media (min-width:1025px) and (max-width:1300px){
  flex-direction: flex;
width: 100%;
  height: auto;
  align-items: center;
  text-align: center;
  justify-content: center;
}
@media (min-width:1441px) and (max-width:2100px){
  
width: 100%;
  height: auto;
  align-items: center;
  text-align: center;
  justify-content: center;
  
}

`;
const Div0 = styled.div`
  align-items: center;
  text-align: center;
display: flex;
margin-left:232px;
/* flex-direction: row; */
`;



const GameArt = () => {
  const [toggle, setToggle] = useState(1)

  function updateToggle(id) {
    setToggle(id)
  }
  const cards = [
    { title: '2D & 3D GAME ART Strategy', description: 'Our 3D game, "Galactic Odyssey," we will focus on crafting a detailed, photorealist encironment that simulates the sense of exploration and discovery. We will utilize high-poly models, detailed textures, and advanced lighting techniques to create an immersive experience', img: serviceImage },
    { title: '2D & 3D Game ART Design', description: 'Our characters will be designed with attention to detail, from the intricate patterns on thier clothing to the subtle animations that bring thier movements to life. By blending realistic textures and fantastical elements, we will create a visually stunning game that transports players to a mystical world.', img: serviceImage1 },
    { title: '2D & 3D GAME ART Texture', description: 'In 3D modeling, texture is the art of adding a layer of depth and realism to our creations. its the process of applying a 2D image or pattern to the surface of our 3D model, giving it a unique and life like apperance. From intericate details to subtle nuances, texuring can completlely transform the look and feel of our models', img: serviceImage2 },
    { title: '3D GAME ART UV Map and Unwrap', description: 'In the realm of 3D art, UV mapping and unwrapping are crucial techniques used to flatten a 3D objects surface onto a 2D plane, allowing for efficient texture application and manipulation. imagine a 3D sphere. its surface is complex and curved, making it difficult to applua texture directly.', img: serviceImage3 },
    { title: 'CREATE 2D GAME ART', description: 'As I dip my brush into the vibrant blue paint, i feel my imagination trasport to a whimsical world. I encision a swirling votex of shapes and colors, as if the very essence of the universe has been distilled onto the cavas. With bold strokes and delibrate precision, i bring forth a mesmerizing landscape of swirling clouds, radiant starts,', img: serviceImage4 },

  ];
  return (
    <>

      <MainWrapContanier>
        <Div>

          <MobileAppImage src={webdevelopment} alt='Background' />
          {/* <MobileAppImage1 src={websitecover} alt = 'Background'/> */}
          {/* <MobileAppImage2 src={websitecober1} alt = 'Background'/>
          <HeadH2>GAMES<br></br> DEVELOPMENT</HeadH2> */}

        </Div>
        <ContanierHead>
          <ContanierRhtHead data-aos="fade-right">
            We Create Immersive 2D & 3D Masterpiece!
            <MobilePara data-aos="fade-right">View Work</MobilePara>
          </ContanierRhtHead>

          <ContanierMobile>
            <MobileImage data-aos="flip-left" src={bannermobile} alt='Image not found' />
          </ContanierMobile>
        </ContanierHead>


        {/* Cards Section */}
        <Container19>

          <HeaderWeb data-aos="fade-right">Our Process</HeaderWeb>

          <Div3>


            <CardContainer>
              {cards.map((card, index) => (
                <Card
                  data-aos="flip-left"
                  data-aos-easing="ease-out-cubic"
                  data-aos-duration="2000"
                  key={index}>
                  <CardImage src={card.img} alt={card.title} />
                  <CardTitle>{card.title}</CardTitle>
                  <CardDescription>{card.description}</CardDescription>
                </Card>
              ))}
            </CardContainer>

          </Div3>
        </Container19>

        <Container20>
          <HeaderWeb data-aos="fade-right">Ignite Your Vision with Big Heap Tech's Trustworthy 2D & 3D Game Art Pipeline</HeaderWeb>
          <PeraWeb data-aos="fade-right">Bigin your project journey with Big Heap Tech trusted 2D & 3D Game Art process. We follow a
            straightforward procedure to ensure efficent progress </PeraWeb>

          <ImageUiUx src={imageuiux} alt='NOT FOUND' />
        </Container20>


        {/* Tab Navigation Section */}

        <TabNavigation>
          <Dflex>
            <FlexFill
              onClick={() => updateToggle(1)}
              active={toggle === 1}
            >
              2D Tools
            </FlexFill>
            <FlexFill
              onClick={() => updateToggle(2)}
              active={toggle === 2}
            >
              3D Tools
            </FlexFill>

          </Dflex>

          <TabContents show={toggle === 1}>
            <Div2>
              <CardTools1 data-aos="flip-left">
                <TechImage1 src={Rectangle1111} alt='Image Not fOUND' />

              </CardTools1>
              <CardTools1 data-aos="flip-left">
                <TechImage1 src={Rectangle1122} alt='Image Not fOUND' />

              </CardTools1>
              <CardTools1 data-aos="flip-left">
                <TechImage1 src={Rectangle1133} alt='Image Not fOUND' />

              </CardTools1>
              <CardTools1 data-aos="flip-left">
                <TechImage1 src={Rectangle1144} alt='Image Not fOUND' />

              </CardTools1>
              <CardTools1 data-aos="flip-left">
                <TechImage1 src={Rectangle1155} alt='Image Not fOUND' />

              </CardTools1>

            </Div2>



          </TabContents>

          <TabContents show={toggle === 2}>
            <Div2>
              <CardTools1 data-aos="flip-left">
                <TechImage1 src={Rectangle111} alt='Image Not fOUND' />

              </CardTools1>
              <CardTools1 data-aos="flip-left">
                <TechImage1 src={Rectangle112} alt='Image Not fOUND' />

              </CardTools1>
              <CardTools1 data-aos="flip-left">
                <TechImage1 src={Rectangle113} alt='Image Not fOUND' />

              </CardTools1>
              <CardTools1 data-aos="flip-left">
                <TechImage1 src={Rectangle114} alt='Image Not fOUND' />

              </CardTools1>
              <CardTools1 data-aos="flip-left">
                <TechImage1 src={Rectangle115} alt='Image Not fOUND' />

              </CardTools1>

            </Div2>


          </TabContents>








        </TabNavigation>

      </MainWrapContanier>

    </>
  )
}

export default GameArt
